// @flow
import type { PersistedMedia } from '../../../components/types'

type PutAction = {|
  +type: 'MEDIAS.PUT',
  +storeId: string,
  +media: PersistedMedia
|}

type State = { [string]: PersistedMedia }

export type { State }

const initialState: State = {}

export function put(storeId: string, media: PersistedMedia): PutAction {
  return {
    type: 'MEDIAS.PUT',
    storeId,
    media
  }
}

export default function medias(state: State = initialState, action: PutAction) {
  switch (action.type) {
    case 'MEDIAS.PUT':
      return { ...state, [action.storeId]: action.media }
    default:
      return state
  }
}
